import React, {Component} from 'react';
import { FormattedMessage } from 'react-intl';
import { IntlConsumer } from '../IntlProviderWrapper';
import './LanguageButton.scss';

export default class LanguageButton extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {className} = this.props
    return (
      <IntlConsumer>
        {({locale, toggleLocale}) => (
          <button onClick={toggleLocale} className={`LanguageButton ${className}`}><FormattedMessage id='languageButton'/></button>
        )}
      </IntlConsumer>
    )
  }
}



// WEBPACK FOOTER //
// ./registration-react/components/LanguageButton/LanguageButton.js